<template>
  <el-dialog
    title="退款处理"
    :visible.sync="dialogVisible"
    width="600px"
    @close="handleClose"
  >
    <el-form
      ref="userRefundForm"
      :model="formData"
      :rules="rules"
      label-width="120px"
      v-loading="loading"
    >
      <el-form-item label="订单号">
        <el-input v-model="order.sn" :disabled="true"></el-input>
      </el-form-item>

      <el-form-item label="退款计划">
        <el-input v-model="plan.title" :disabled="true"></el-input>
      </el-form-item>

      <el-form-item label="距离出发">
        <el-input :value="near_day + '天'" :disabled="true"></el-input>
      </el-form-item>

      <el-form-item label="订单金额">
        <el-input v-model="order.amount" :disabled="true"></el-input>
      </el-form-item>

   

      <el-form-item label="手续费率">
        <el-input v-model="itm.rate" :disabled="true"></el-input>
      </el-form-item>
      <el-form-item label="手续费-每人">
        <el-input v-model="itm.inc" :disabled="true"></el-input>
      </el-form-item>

      <el-form-item label="手续费金额">
        <el-input :value="planInfo.fee_amount" :disabled="true"></el-input>
      </el-form-item>

      <el-form-item label="退款金额">
        <el-input v-model="planInfo.refund_amount" :disabled="true"></el-input>
      </el-form-item>

      <el-form-item label="用户申请原因">
        <el-input
          type="textarea"
          v-model="planInfo.back_note"
          :rows="3"
          :disabled="true"
        ></el-input>
      </el-form-item>

    

    
      <el-form-item label="退款状态" prop="back_status">
        <el-radio-group v-model="formData.back_status">
          
          <el-radio :label="2">同意按计划退款</el-radio>
          <el-radio :label="3">后台全额退款</el-radio>
          <el-radio :label="4">拒绝退款</el-radio>
        </el-radio-group>
      </el-form-item>
        <el-form-item label="退款手续费(给巴士公司)" v-if="formData.back_status == 2">
        <el-input v-model="formData.ticket_refund_jp_money" ></el-input>
      </el-form-item>
      
    </el-form>

    <div slot="footer" class="dialog-footer">
      <div  class="tips" >
      当前当前订单退款状态为
      <span>
      {{['未申请', '申请退款', '同意按计划退款', '后台全额退款', '拒绝退款'][order.back_status]}}
      </span>
      </div>
      <el-button @click="handleClose">取消</el-button>
      <el-button type="primary" @click="handleSubmit" :loading="submitting">确定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import axios from 'axios'

export default {
  name: 'UserRefundDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    orderId: {
      type: [String, Number],
      default: null
    }
  },
  data() {
    return {
      dialogVisible: false,
      loading: false,
      submitting: false,
      order : {},
      plan: {},
      itm : {},
      planInfo:{
        fee_amount: 0,
        refund_amount: 0
      },
      near_day : 0,
      formData: {
        id:0,
        back_status: 1,
        back_note: '',
        type: 1,
        ticket_refund_jp_money: 0
      },
      rules: {
        back_status: [
          { required: true, message: '请选择退款状态', trigger: 'change' }
        ],
        back_note: [
          { required: true, message: '请输入处理备注', trigger: 'blur' }
        ],
        type: [
          { required: true, message: '请选择处理类型', trigger: 'change' }
        ],
        ticket_refund_jp_money: [
          { required: true, message: '请输入退款金额', trigger: 'blur' }
        ]
      }
    }
  },
  watch: {
    visible(newVal) {
      this.dialogVisible = newVal
      if (newVal && this.orderId) {
        this.loadFormData()
      }
    },
    dialogVisible(newVal) {
      if (!newVal) {
        this.$emit('update:visible', false)
      }
    },
    'formData.back_status'(newVal) {
      // 当选择同意退款时，设置默认退款金额
      if (newVal === 3 && this.planInfo.refund_amount) {
        const amount = parseFloat(this.planInfo.refund_amount.replace(/[^\d.]/g, ''))
        if (!isNaN(amount)) {
          this.formData.ticket_refund_jp_money = amount
        }
      }
    }
  },
  methods: {
    async loadFormData() {
      if (!this.orderId) return
      this.formData.id = this.orderId
      this.loading = true
      try {
        const response = await axios.get(`${this.base_url}/orders/user_back_pre/${this.orderId}`)
        if (response.status === 200 && response.data.code) {
          const data = response.data.data
          this.order = data.order 
          this.plan = data.plan
          this.itm = data.itm
          this.near_day = data.near_day
          this.man_num = data.man_num
          this.planInfo.refund_amount = data.refund_money
          this.planInfo.fee_amount =   data.rate
        } else {
          this.$message.error(response.data.message || '获取表单数据失败')
        }
      } catch (error) {
        console.error('获取表单数据失败:', error)
        this.$message.error('获取表单数据失败')
      } finally {
        this.loading = false
      }
    },

    async handleSubmit() {
      this.$refs.userRefundForm.validate(async (valid) => {
        if (valid) {
          this.submitting = true
          try {
            const response = await axios.post(`${this.base_url}/ordersuser_back_do`, this.formData)
            if (response.status === 200 && response.data.code) {
              this.$message.success('用户退款处理成功')
              this.dialogVisible = false
              this.$emit('success')
            } else {
              this.$message.error(response.data.message || '退款处理失败')
            }
          } catch (error) {
            console.error('退款处理失败:', error)
            this.$message.error('退款处理失败')
          } finally {
            this.submitting = false
          }
        } else {
          this.$message.error('请检查表单填写是否正确')
        }
      })
    },

    handleClose() {
      this.dialogVisible = false
      this.resetForm()
    },

    resetForm() {
      this.$refs.userRefundForm && this.$refs.userRefundForm.resetFields()
      this.formData = {
        back_status: 1,
        back_note: '',
        type: 1,
        ticket_refund_jp_money: 0
      }
      this.planInfo = {
        plan_title: '',
        near_day: 0,
        order_amount: '',
        curr_amount: '',
        fee_rate: '',
        fee_amount: '',
        refund_amount: '',
        back_note: ''
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.dialog-footer {
  text-align: right;
}

.el-form {
  .el-select {
    width: 100%;
  }
}

.tips {
  padding: 5px;
  span {
    color: red;
    font-weight: bold;
  }
}
.el-form-item {
  margin-bottom: 5px;
}
</style>